import { render, staticRenderFns } from "./CalculatorPersonalGainNotice.vue?vue&type=template&id=317c16af&scoped=true"
import script from "./CalculatorPersonalGainNotice.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonalGainNotice.vue?vue&type=script&lang=js"
import style0 from "./CalculatorPersonalGainNotice.vue?vue&type=style&index=0&id=317c16af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c16af",
  null
  
)

export default component.exports